<!--
 * @Description: 数据分析入口
 * @Date: 2021-10-21 20:01:49
-->
<template>
  <div>
    <el-tabs
      style="background:#FFF;padding: 15px 15px 0px 15px;"
      v-model="activeTask"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.label"
        :label="tab.label"
        :name="tab.name"
      ></el-tab-pane>
    </el-tabs>
    <active-list v-if="activeTask === 'activeList'" />
    <project-container v-if="activeTask === 'recordList'"></project-container>
    <summary-container v-if="activeTask === 'tasksum'"></summary-container>
  </div>
</template>

<script>
import projectContainer from './views/task-record/container';
import summaryContainer from './views/task-summary';
import initProject from './mixins/sync-project';
import { mapMutations } from 'vuex';
import { judge } from '@/Mixin/judge';
import ActiveList from '@/page/project-record/views/active-list';

export default {
  name: 'taskMgmtContainer',
  mixins: [initProject, judge],
  // 命名怪异的问题 产品解释说是 初衷是做合规性抽查，所以叫数据分析，后来就变味了。 开发角度来看，其实就是任务管理
  components: { ActiveList, projectContainer, summaryContainer },
  provide() {
    return {
      isOpenedByOther: !!this.$route.query.isOpenedByOther
    };
  },
  data() {
    return {
      activeTask: '',
      tabs: []
    };
  },
  computed: {
    showActivity() {
      return +this.$store.state.homeProject.fileUpMode === 1;
    }
  },
  watch: {
    '$route.query': {
      handler(v) {
        this.activeTask = v.activeTask || this.activeTask;
      }
    }
  },
  created() {
    // tabs 数据
    let tabsData = [
      { label: '活动列表', name: 'activeList' },
      { label: '任务记录', name: 'recordList' },
      { label: '任务汇总', name: 'tasksum' }
    ];

    const {
      projectType,
      fileUpMode,
      fileUpSource
    } = this.$store.state.homeProject;

    // 协定服务，活动上传显示 活动列表tab；
    const showActivity =
      +projectType === 19 && (+fileUpMode === 1 || fileUpSource === 3);

    // 不展示就去掉
    !showActivity && tabsData.shift();

    // 设置 tabs
    this.tabs = tabsData;

    // 默认tab
    const defaultTabName = tabsData[0].name;

    // 设置 活动 tab
    this.activeTask = this.$route.query.activeTask || defaultTabName; // OSS暂不需要该处理

    // fileUpMode: 0, // 1活动维度 2人维度
    // fileUpSource: 0 // 1ASP上传 2C上传 3双方上传
  },
  methods: {
    ...mapMutations('dataAnalysis', ['RESET_STATE'])
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    const allowRouterName = ['taskCheckLog', 'taskQuickAuditList'];
    if (!allowRouterName.includes(to.name)) {
      this.RESET_STATE();
    }
    next();
  }
};
</script>

<style scoped></style>
